/**
 * MenuEditorModal — create or edit a reusable menu in the library (name + the
 * shared MenuItemsEditor). Presentational: the parent decides create vs update
 * via onSave(data).
 */
import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import MenuItemsEditor from './MenuItemsEditor';
import { blankMenu } from '../eventUtils';
import { t } from '../strings';

export default function MenuEditorModal({ open, initial, onClose, onSave }) {
  const [menu, setMenu] = useState(blankMenu());
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) { setMenu(initial ? { ...initial } : blankMenu()); setSaving(false); }
  }, [open, initial]);

  const save = async () => {
    if (!menu.name.trim()) return;
    setSaving(true);
    try {
      await onSave({ name: menu.name.trim(), items: menu.items || [] });
      onClose();
    } catch {
      setSaving(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} title={initial && initial.id ? t('editMenu') : t('newMenu')} maxWidth={620}>
      <label className="ev-lbl">{t('menuName')}</label>
      <input className="ev-input" placeholder={t('menuNamePlaceholder')}
        value={menu.name} onChange={(e) => setMenu((m) => ({ ...m, name: e.target.value }))} />
      <div style={{ height: 14 }} />
      <MenuItemsEditor items={menu.items || []} onChange={(items) => setMenu((m) => ({ ...m, items }))} />
      <div className="ev-confirm__actions" style={{ marginTop: 16 }}>
        <button className="ev__btn" onClick={onClose} disabled={saving}>{t('cancel')}</button>
        <button className="ev__btn ev__btn--primary" onClick={save} disabled={saving || !menu.name.trim()}>
          {saving ? '…' : t('saveMenu')}
        </button>
      </div>
    </Modal>
  );
}
